import React, { FC, useEffect, useState } from 'react';
import Sheet from '@mui/joy/Sheet';
import Stack from '@mui/material/Stack';
import useScreenWidth from '../../../../store/useScreenWidth';
import useGetByAssignedTo from '../../../../store/ReactQueries/dashboards/useGetByAssignedTo';
import { BarChart } from '@mui/x-charts/BarChart';
import { darkModeBackgroud } from '../../../../utils/constants';
import { TicketsByAssignTo } from '../../../../models/Dashboard';
import { useDarkModeStore } from '../../../../store/useDarkModeStore';
import { useLanguageStore } from '../../../../store/useLanguageStore';
export const cardStyle = {
    py: 0,
    px: 0,
    width: 'auto',
    height: '364px',
    display: 'flex',
    borderRadius: 'md',
    flexDirection: 'column',
    boxShadow: 'rgba(50, 71, 92, 0.1) 0px 2px 10px 0px',
};

const ticketsToStaffData: TicketsByAssignTo[] = [
    { firstname: '', lastname: '', ticketCount: 2 },
];

interface TicketsToStaffProp {
    height?: number;
    year: number;
}

const TicketsToStaff: FC<TicketsToStaffProp> = ({ height, year }) => {
    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore();
    const { data } = useGetByAssignedTo(year);
    const isSmallScreen = useScreenWidth();

    const [chartData, setChartData] = useState<TicketsByAssignTo[]>(ticketsToStaffData);

    useEffect(() => {
        if (data) setChartData(data);
        else setChartData(ticketsToStaffData);
    }, [data]);

    const upCardStyle = {
        ...cardStyle,
        height: height ? `${height}px` : '300px',
        background: darkMode ? darkModeBackgroud : 'white',
    };

    const noDataMessageStyle = {
        height: '100%',
        display: 'flex',
        fontSize: '18px',
        fontWeight: 'bold',
        alignItems: 'center',
        justifyContent: 'center',
        color: darkMode ? 'white' : 'rgba(50, 71, 92, 0.87)',
    };

    const itemHeight = isSmallScreen ? 30 : 80;
    const dynamicTranslateY = (1 / (chartData.length * itemHeight)) + 40;

    return <Sheet sx={upCardStyle}>
        <div className="d-flex flex-row justify-content-between position-relative height-fill-available">
            <div className="p-4" style={{ width: '100%' }}>
                <h5 style={{ color: darkMode ? 'white' : 'rgba(50, 71, 92, 0.87)', opacity: 0.9 }}>
                    {language['TicketsToStaff']}
                </h5>
                <hr className={darkMode ? 'text-white opacity-100' : ''} />
                <Stack
                    spacing={1}
                    direction="column"
                    sx={{ width: '100%', height: '80%' }}
                >
                    {chartData.length > 0
                        ? <BarChart
                            height={250}
                            grid={{ horizontal: true }}
                            series={[
                                {
                                    data: chartData?.map(({ ticketCount }) => ticketCount),
                                    color: '#696CFF',
                                },
                            ]}
                            margin={{
                                top: 20,
                                bottom: 20,
                            }}
                            xAxis={[
                                {
                                    scaleType: 'band',
                                    data: chartData?.map((item) => (item.firstname && item.lastname)
                                        ? `${item.firstname} ${item.lastname}`
                                        : language['NotAssigned']),
                                    valueFormatter: (value) => value,
                                    colorMap: {
                                        type: 'piecewise',
                                        thresholds: [2, 6],
                                        colors: ['blue', 'red', 'blue'],
                                    },
                                    tickLabelStyle: {
                                        textAnchor: 'middle',
                                        dominantBaseline: 'central',
                                        fill: darkMode ? 'white' : '',
                                        transform: `rotate(-90deg) translate(0, ${dynamicTranslateY}px)`,
                                    },
                                },
                            ]}
                            yAxis={[
                                {
                                    colorMap: {
                                        type: 'piecewise',
                                        thresholds: [0],
                                        colors: ['#696CFF', '#696CFF'],
                                    },
                                    tickLabelStyle: { fill: darkMode ? 'white' : '' }
                                },
                            ]}
                        />
                        : <div style={noDataMessageStyle}>
                            {language['NoDataToDisplay'] || 'No data available'}
                        </div>
                    }
                </Stack>
            </div>
        </div>
    </Sheet>
};

export default TicketsToStaff;